import React from 'react'
import styles from './styles.module.css'

interface TabProps extends React.ComponentPropsWithoutRef<'a'> {
  children: string
  selected?: boolean
  hidden?: boolean
}

const Tab = React.forwardRef<HTMLLIElement, TabProps>(
  ({ children, selected, hidden, ...rest }, ref) => {
    if (hidden) return null

    return (
      <li ref={ref} className={styles.listItem}>
        <span {...rest} className={`${styles.link} ${selected ? styles.selected : ''}`}>
          {children}
        </span>
      </li>
    )
  }
)

export default Tab
